var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.domainBasedBrand)?[_c('catalog')]:[_c('offer-list'),_c('FilterPanel'),_c('Offer'),_c('BrandsList')],_c('tap-top')],2),(!_vm.domainBasedBrand && _vm.customizationLocal.app_section_availability)?_c('AppSection'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }